import { render, staticRenderFns } from "./RechargeView.vue?vue&type=template&id=bbb00684&scoped=true&"
import script from "./RechargeView.vue?vue&type=script&lang=js&"
export * from "./RechargeView.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/recharge.css?vue&type=style&index=0&id=bbb00684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb00684",
  null
  
)

export default component.exports